/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React from "react";
import { connect } from "react-redux";
//table imports
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import Collapse from "@mui/material/Collapse";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import { withTranslation } from "react-i18next";
import currencyFormatter from "../../../helper/currencyFormatter";
import { TableContainer } from "@mui/material";

const ComponentAssembly = (props) => {
  const { t } = props;
  const getPriceTenureUOM = (val) => {
    if (val === "TF_day") {
      return "Day";
    } else if (val === "TF_hr" || val === "HOUR") {
      return "Hour";
    } else if (val === "TF_wk") {
      return "Week";
    } else if (val === "TF_mon") {
      return "Month";
    } else if (val === "TF_yr") {
      return "Year";
    } else if (val === "DAY") {
      return "Day";
    } else if (val === "WEEK") {
      return "Week";
    } else if (val === "MONTH") {
      return "Month";
    } else if (val === "YEAR") {
      return "Year";
    } else {
      return "";
    }
  };
  const LineItem = (item) => {
    return (
      <TableRow>
        <TableCell
          colSpan={5}
          style={{ padding: "0px 0 0px 50px", borderBottom: 0 }}
        >
          <Collapse in={true} timeout="auto" unmountOnExit>
            <TableContainer>
              <Table>
                <TableBody>
                  {item.data.map((child, childIndex) => (
                    <React.Fragment key={childIndex}>
                      <TableRow>
                        {/* <TableCell style={{ width: '5%', borderBottom: 0 }}></TableCell> */}
                        <TableCell style={{ width: "30%" }}>
                          {child.name}
                        </TableCell>
                        <TableCell style={{ width: "30%" }}>
                          {child.description ? child.description : "-"}
                        </TableCell>
                        <TableCell style={{ width: "15%" }}>
                          {currencyFormatter(child.price)}{" "}
                          {item.type === "assembly" && child.priceType === "NTC"
                            ? "NRC"
                            : child.priceType}{" "}
                          {child.priceType === "NTC"
                            ? child.priceTenure > 1
                              ? "(" +
                                "per " +
                                child.priceTenure +
                                " " +
                                getPriceTenureUOM(child.priceTenureUOM) +
                                "s" +
                                ")"
                              : "(" +
                                "per " +
                                getPriceTenureUOM(child.priceTenureUOM) +
                                ")"
                            : ""}
                        </TableCell>
                        {item.type === "assembly" && (
                          <TableCell style={{ width: "15%" }}>
                            {child.presetQuantity}
                          </TableCell>
                        )}
                        <TableCell style={{ width: "15%" }}>
                          {child.featureCode}
                        </TableCell>
                        <TableCell
                          style={{ width: "5%", borderBottom: 0 }}
                        ></TableCell>
                      </TableRow>
                      {child.children && child.children.length > 0 && (
                        <LineItem data={child.children} type={"assembly"} />
                      )}
                      {child.variants && child.variants.length > 0 && (
                        <LineItem data={child.variants} type={"component"} />
                      )}
                    </React.Fragment>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Collapse>
        </TableCell>
      </TableRow>
    );
  };
  return (
    <React.Fragment>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={9}>
          <Collapse in={props.expandVariants} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <TableContainer>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      {/* <TableCell align="left"></TableCell> */}
                      <TableCell align="left">
                        <b>{t("NAME")}</b>
                      </TableCell>
                      <TableCell align="left">
                        <b>{t("DESCRIPTION")}</b>
                      </TableCell>
                      <TableCell align="center">
                        <b>
                          {t("PRICE")}{" "}
                          {"(" + currencyFormatter("", false) + ")"}
                        </b>
                      </TableCell>
                      <TableCell align="center">
                        <b>{t("QUANTITY")}</b>
                      </TableCell>
                      <TableCell align="center">
                        <b>{t("PRODUCT_CODE")}</b>
                      </TableCell>
                      {/* <TableCell align="center"><b>{t('ACTION')}</b></TableCell> */}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {props.data.children &&
                      props.data.children.length > 0 &&
                      props.data.children.map(
                        (opt, componentIndex) =>
                          !opt.remove && (
                            <React.Fragment key={componentIndex}>
                              <TableRow
                                style={{
                                  backgroundColor: !opt.expandKitComponents
                                    ? "#ffffff"
                                    : "#eee",
                                }}
                              >
                                {/* <TableCell style={{ width: '5%' }}>
                                                    {opt.children && opt.children.length > 0 &&
                                                        <Tooltip title={t('EXPAND_KIT_PRODUCTS')}>
                                                            <IconButton aria-label="expand row" size="small"
                                                                onClick={(event) => {
                                                                    props.expandKitComponentsTable(event, opt, !opt.expandKitComponents);
                                                                }}
                                                            >
                                                                {opt.expandKitComponents ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                            </IconButton>
                                                        </Tooltip>
                                                    }
                                                </TableCell> */}
                                <TableCell
                                  style={{ width: "30%" }}
                                  component="th"
                                  scope="row"
                                >
                                  {/* <Input
                                                name={'name'}
                                                value={opt.name}
                                            // onChange={event => props.onVariantChange(event, componentIndex)}
                                            /> */}
                                  {opt.name}
                                </TableCell>
                                <TableCell
                                  style={{ width: "30%" }}
                                  component="th"
                                  scope="row"
                                >
                                  {/* <Input
                                                name={'description'}
                                                value={opt.description}
                                                multiline={true}
                                                inputProps={{ rows: 1, cols: 31 }}
                                            // onChange={event => props.onVariantChange(event, componentIndex)}
                                            /> */}
                                  {opt.description}
                                </TableCell>
                                <TableCell
                                  style={{ width: "15%" }}
                                  align="center"
                                >
                                  {/* <Input
                                                name={'price'}
                                                type={'number'}
                                                value={opt.price}
                                            // onChange={event => props.onVariantChange(event, componentIndex)}
                                            /> */}
                                  {currencyFormatter(opt.price)}{" "}
                                  {opt.priceType === "NTC"
                                    ? "NRC"
                                    : opt.priceType}{" "}
                                  {opt.priceType === "NTC"
                                    ? opt.priceTenure > 1
                                      ? "(" +
                                        "per " +
                                        opt.priceTenure +
                                        " " +
                                        getPriceTenureUOM(opt.priceTenureUOM) +
                                        "s" +
                                        ")"
                                      : "(" +
                                        "per " +
                                        getPriceTenureUOM(opt.priceTenureUOM) +
                                        ")"
                                    : ""}
                                </TableCell>
                                <TableCell
                                  style={{ width: "15%" }}
                                  align="center"
                                >
                                  {opt.presetQuantity}
                                </TableCell>
                                <TableCell
                                  style={{ width: "15%" }}
                                  align="center"
                                >
                                  {/* <Input
                                                name={'featureCode'}
                                                value={opt.featureCode}
                                            // onChange={event => props.onVariantChange(event, componentIndex)}
                                            /> */}
                                  {opt.featureCode}
                                </TableCell>
                                {/* <TableCell align="center" style={{ width: '5%' }}>
                                                    <Delete onClick={event => props.removeKit(event, opt)} />
                                                </TableCell> */}
                              </TableRow>
                              {opt.children && opt.children.length > 0 && (
                                <TableRow>
                                  <TableCell
                                    colSpan={5}
                                    style={{ padding: "0px 0 0px 0px" }}
                                  >
                                    <Collapse
                                      in={true}
                                      timeout="auto"
                                      unmountOnExit
                                    >
                                      <TableContainer>
                                        <Table>
                                          <LineItem
                                            data={opt.children}
                                            type={"assembly"}
                                          />
                                        </Table>
                                      </TableContainer>
                                    </Collapse>
                                  </TableCell>
                                </TableRow>
                              )}
                              {opt.variants && opt.variants.length > 0 && (
                                <TableRow>
                                  <TableCell
                                    colSpan={5}
                                    style={{ padding: "0px 0 0px 0px" }}
                                  >
                                    <Collapse
                                      in={true}
                                      timeout="auto"
                                      unmountOnExit
                                    >
                                      <TableContainer>
                                        <Table>
                                          <LineItem
                                            data={opt.variants}
                                            type={"component"}
                                          />
                                        </Table>
                                      </TableContainer>
                                    </Collapse>
                                  </TableCell>
                                </TableRow>
                              )}
                            </React.Fragment>
                          ),
                      )}
                    {props.data.children &&
                      props.data.children.length === 0 && (
                        <TableRow>
                          <TableCell colSpan={6} align="center">
                            {t("NO_COMPONENTS_ADDED")}
                          </TableCell>
                        </TableRow>
                      )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            {/* <Button onClick={() => { this.addVariantRow() }} style={{ float: 'right', marginBottom: '5px' }} color="primary">Add Variant</Button> */}
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    providerId: state.auth.tenantId,
    providerType: state.auth.providerType,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    //setErrorMessage: (errMsg, msgType) => dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType })
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(ComponentAssembly));
